const SetPlannedDynamic = async (id) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `Admin/setPlannedDynamic/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (!response.ok) {
            return { success: false, message: 'Error al establecer la dinámica planificada.' }
        }
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de red.' }
    }
}

const SendWelcomePage = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/sendWelcome", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (!response.ok) {
            return { success: false, message: 'Error al enviar la bienvenida general.' }
        }
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de red.' }
    }
}

const ShowWelcomePage = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/welcome", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (!response.ok) {
            return { success: false, message: 'Error al mostrar la portada.' }
        }
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de red.' }
    }
}

const StartNoisemeter = async (gameData) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/start", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(gameData)
        })
        
        if (!response.ok) {
            let errorMessage = 'No ha sido posible iniciar el Ladrómetro.';
            try {
                const errorData = await response.json();
                if (errorData && errorData.message) errorMessage = errorData.message;
            } catch (e) {
                errorMessage += ` (${response.statusText})`;
            }
            return { success: false, message: errorMessage }
        }
        
        const data = await response.json();
        return { success: true, data: data }

    } catch (error) {
        return { success: false, message: 'Error de conexión al iniciar el Ladrómetro.' }
    }
}

const StopNoisemeter = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/stop", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al detener el Ladrómetro.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de conexión al detener.' }
    }
}

const ResetNoisemeter = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/reset", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al reiniciar.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Error de conexión al reiniciar.' }
    }
}

const GetNoisemeterStats = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/stats", {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            return { success: false, message: 'Error obteniendo estadísticas.' }
        }

        const data = await response.json();
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de conexión.' }
    }
}

const GetActiveZones = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/GetActiveZones", { 
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

        if (!response.ok) {
            return { success: false, message: 'No se pudieron cargar las zonas.' }
        }

        const data = await response.json();
        return { success: true, data: data } 
    } catch (error) {
        return { success: false, message: 'Error al consultar zonas activas.' }
    }
}

//===== FAN =====//

const ReportNoiseLevel = async (reportData) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/report", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reportData)
        })
        
        if (!response.ok) {
            return { success: false, message: response.message }
        }
        
        return { success: true, data: null }

    } catch (error) {
        return { success: false, message: error }
    }
}

//===== SCREEN =====//

const GetNoisemeterState = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "v2/noisemeter/stats", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            return { success: false, message: 'Error de conexión.' }
        }
        
        const data = await response.json()
        return { success: true, data: data }

    } catch (error) {
        return { success: false, message: 'Error de red.' }
    }
}

export { SetPlannedDynamic, SendWelcomePage, ShowWelcomePage, StartNoisemeter, StopNoisemeter, ResetNoisemeter, GetNoisemeterStats, GetActiveZones, ReportNoiseLevel, GetNoisemeterState };
